
export interface AffectedCharacters {
  playerName: string;
  character: string;
}

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ColtExpress',
  data() {
    return {
      numberOfPlayer: 2,
      playerNames: [] as Array<string>,
      charactersNames: ['Ghost', 'Cheyenne', 'Django', 'Belle', 'Tuco', 'Doc'],
      affectedCharacters: [] as Array<AffectedCharacters>,
    };
  },
  computed: {
    isValidForm(): boolean {
      return (
        this.playerNames.length === this.numberOfPlayer &&
        this.playerNames.every(
          (playerName: string) =>
            playerName?.trim()?.length > 0 && playerName !== null,
        )
      );
    },
    isAvailableResult(): boolean {
      return this.affectedCharacters.length > 0;
    },
  },
  methods: {
    affectCharacters(): void {
      this.resetAffectedCharacters();
      const charactersNamesCopied = [...this.charactersNames];
      this.playerNames.forEach((playerName: string) => {
        const idx = Math.floor(Math.random() * charactersNamesCopied.length);
        const character: string = charactersNamesCopied[idx];
        this.affectedCharacters.push({
          playerName,
          character,
        });
        charactersNamesCopied.splice(idx, 1);
      });
    },
    resetAffectedCharacters(): void {
      this.affectedCharacters = [];
    },
  },
});
